<div
  style="width: 100%"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <nav class="navbar navbar-expand-lg navbar-light topnav">
    <div style="text-align: center; width: 100%">
      <img
        [src]="urlLogoIDS"
        alt="LOGOIDS"
        class="img-fluid img-thumbnail"
        style="background-color: transparent; border: none"
        width="200px"
      />
    </div>
  </nav>
  <div class="container" fxFill>
    <div class="signInForm">
      <div class="row justify-content-center">
        <div class="col-md-7 col-sm-12">
          <div class="card">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link active signIn" data-toggle="tab">SIGN IN</a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="signIn" class="container tab-pane active">
                <form
                  [formGroup]="signInForm"
                  (ngSubmit)="onSignIn()"
                  novalidate
                >
                  <div style="display: flex; justify-content: center">
                    <mat-spinner
                      class="spinner"
                      *ngIf="loadingSignIn || verifing"
                    ></mat-spinner>
                  </div>
                  <div [hidden]="loadingSignIn || verifing">
                    <div class="row">
                      <p class="sign-in-to-your-ids-account">
                        Get access to
                        {{ company_name }} now
                      </p>
                      <p class="your-account-is-your">
                        <!-- Your account is your portal to all things {{ company_name }}: your job tasks, email, calendar, report, and more! -->
                        A system that doesn't slow you down
                      </p>
                      <p
                        class="verify-success"
                        *ngIf="isVerified && isVerified.message"
                        [ngClass]="{ error: !isVerified.status }"
                      >
                        <i class="material-icons" *ngIf="isVerified.status"
                          >check_circle</i
                        >
                        <i class="material-icons" *ngIf="!isVerified.status"
                          >error</i
                        >
                        <span>{{ isVerified.message }}</span>
                      </p>
                    </div>
                    <div class="row">
                      <mat-form-field class="col-12">
                        <input
                          matInput
                          name="email"
                          type="email"
                          placeholder="Email address"
                          required
                          formControlName="email"
                        />
                        <mat-error
                          *ngIf="signInForm.get('email').hasError('required')"
                        >
                          A valid email address is required.
                        </mat-error>
                        <mat-error
                          *ngIf="
                            !signInForm.get('email').hasError('required') &&
                            signInForm.get('email').hasError('email')
                          "
                        >
                          Email address is invalid.
                        </mat-error>
                        <mat-error
                          *ngIf="
                            signInForm.get('email').hasError('emailVerify')
                          "
                        >
                          Please verify email!
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="row">
                      <mat-form-field class="col-12">
                        <input
                          matInput
                          name="password"
                          type="password"
                          placeholder="Password"
                          required
                          formControlName="password"
                        />
                        <mat-error
                          *ngIf="
                            signInForm.get('password').hasError('required')
                          "
                        >
                          Password is required.
                        </mat-error>
                        <mat-error
                          *ngIf="
                            signInForm.get('email').hasError('emailInvalid') ||
                            signInForm
                              .get('password')
                              .hasError('passwordInvalid')
                          "
                        >
                          Email address or password is invalid.
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="row repo-btn-submit" style="margin-top: 30px">
                      <!-- <div class="justify-content"> -->
                      <button
                        class="submitSignIn"
                        type="submit"
                        mat-button
                        color="accent"
                      >
                        SIGN IN
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div > -->
    <div style="width: 100%; height: 100px; display: inline-block"></div>
    <div
      class="container copyright"
      style="margin-top: auto; position: relative; bottom: 30px; width: 100%"
    >
      <span>
        Powered by
        <span>
          <a href="#" class="termsOfUse"
            ><strong>{{ company_name }}</strong></a
          > </span
        >.
      </span>
      <span style="margin-top: 5px">
        Copyright &copy; 2019
        <span>
          <a href="#" class="termsOfUse"
            ><strong>{{ company_name }}</strong></a
          > </span
        >. All rights reserved.
      </span>
    </div>
    <!-- </div> -->
  </div>
</div>
